import React from 'react';
import CatalogueObjectInputs from './CatalogueObjectInputs';

const CatalogueObjectList = ({
  category,
  code,
  field,
  section,
}) => (
  <CatalogueObjectInputs
    category={category}
    code={code}
    field={field}
    fields={field.fields}
    section={section}
  />
);

export default CatalogueObjectList;
